import React, { useEffect, useState } from "react";
import { Loader2, Check, Globe, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import axios from "axios";
import { API_URL as API } from "../config";

const STATO = { verified: ["Verificato", "#1e9e4a"], pending: ["In verifica", "#c58a00"], failed: ["Non verificato", "#c62828"], not_started: ["DNS da aggiungere", "#c58a00"] };

// Pannello Resend: domini verificati e record DNS da aggiungere (invio via API quando il provider SMTP rifiuta l'IP)
export default function ResendPanel({ dominio, onVerificato }) {
  const [stato, setStato] = useState(null);
  const [record, setRecord] = useState(null);
  const [busy, setBusy] = useState(false);

  const carica = () => axios.get(`${API}/relay/resend`).then((r) => setStato(r.data)).catch(() => setStato({ configurato: false, domini: [] }));
  useEffect(() => { carica(); }, []);

  const mio = stato?.domini?.find((d) => d.name === dominio);
  const verificato = mio?.status === "verified";
  useEffect(() => { onVerificato?.(!!verificato); }, [verificato, onVerificato]);

  const aggiungi = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/relay/resend/dominio`, { nome: dominio });
      setRecord(r.data);
      await carica();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Resend non raggiungibile");
    } finally { setBusy(false); }
  };
  const verifica = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/relay/resend/verifica`, { id: mio?.id || record?.id });
      setRecord(r.data);
      await carica();
      toast[r.data.status === "verified" ? "success" : "info"](r.data.status === "verified" ? `Dominio ${dominio} verificato` : "Verifica avviata: i DNS possono richiedere fino a qualche ora");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Verifica non riuscita");
    } finally { setBusy(false); }
  };

  if (!stato) return <div className="manu-text" data-testid="resend-loading"><Loader2 size={14} className="spin" /> Controllo Resend…</div>;
  if (!stato.configurato) return <div className="connect-error" data-testid="resend-missing">Resend non configurato sul server (chiave API mancante).</div>;
  const [label, colore] = STATO[mio?.status] || ["Non registrato", "#666"];
  return (
    <div className="resend-panel" data-testid="resend-panel">
      <div className="resend-row">
        <Globe size={15} /> <b>{dominio}</b>
        <span className="resend-stato" style={{ background: colore }} data-testid="resend-stato">{label}</span>
        {!mio && <button className="wf-btn proto-btn" onClick={aggiungi} disabled={busy} data-testid="resend-add-domain">{busy ? <Loader2 size={14} className="spin" /> : "+"} Registra dominio</button>}
        {mio && !verificato && <button className="wf-btn proto-btn" onClick={verifica} disabled={busy} data-testid="resend-verify"><RefreshCw size={14} /> Verifica DNS</button>}
        {verificato && <Check size={16} color="#1e9e4a" />}
      </div>
      {stato.chiave_etichetta && (
        <div className="manu-text" style={{ opacity: 0.6, fontSize: "0.85em" }} data-testid="resend-chiave-etichetta">
          Chiave Resend in uso: {stato.chiave_etichetta}
        </div>
      )}
      {(record?.records?.length > 0) && !verificato && (
        <div className="resend-records" data-testid="resend-records">
          <div className="manu-text">Aggiungi questi record nel DNS di {dominio}, poi premi "Verifica DNS":</div>
          <table>
            <thead><tr><th>Tipo</th><th>Nome</th><th>Valore</th></tr></thead>
            <tbody>
              {record.records.map((r, i) => (
                <tr key={`${r.type}-${r.name}-${r.value}`}><td>{r.type}</td><td>{r.name}</td><td className="resend-val">{r.value}{r.priority ? ` (priorità ${r.priority})` : ""}</td></tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
